<template>
	<div>
		<div class="vh-100 bg-white">
			<SOTitleBar
				:page-title="pageSetting.pageTitle"
				:type="'close'"
				@back="back"
			/>
			<div class="content-wrapper main-page showPageDefault flex-100">
				<div class="p-x-20 p-y-16 w-limit flex-1">
					<div class="m-d-16">
						<SOInputTextarea
							:title="'Alamat Lengkap'"
							:placeholder="'Alamat & penanda (patokan)...'"
							:required="true"
							:validation="'alphanumeric'"
							v-model="alamatTemp.alamat"
						/>
						<ErrorMessage
							class="error"
							label="Alamat"
							:validation="$v.alamatTemp.alamat"
						/>
						<div class="m-t-16">
							<button class="btn btn-outline-primary" @click="() => { this.pageSetting.showMap = true }">
								<i class="fa fa-map-marker m-r-4"></i>
								Titik Lokasi di Peta
							</button>
							<div class="f-regular f-13 f-c-midgrey m-t-8"
							     v-if="alamatTemp.latitude === 0 && alamatTemp.longitude === 0"
							>
								Tambahkan untuk mempermudah kurir mencari lokasi saat pengantaran.
							</div>
							<div class="m-t-8" v-else>
								<span class="f-regular f-13 f-c-black">Titik lokasi: </span>
								<span class="f-regular f-13 f-c-midgrey">{{ alamatTemp.alamat_gmaps }}</span>
							</div>
						</div>
					</div>

					<div class="m-d-16">
						<SOInputRegular
							:title="'Label Alamat'"
							:placeholder="'Cth: Rumah'"
							:validation="'alphanumeric'"
							v-model="alamatTemp.judul"
						/>
					</div>

					<SOInputCheckbox
						:checkboxes="checkboxAlamatUtama"
						:checked="this.alamatTemp.alamat_utama"
						@selected="(val) => { alamatTemp.alamat_utama = val }"
					/>
				</div>

				<div class="p-x-20 p-d-16 w-limit" v-if="pageSetting.pageType.default">
					<SOButton
						:loading="pageSetting.btn.save.loading"
						:disable="pageSetting.btn.save.disabled"
						:full="true"
						:outline="true"
						:text="'Simpan Alamat'"
						@action="saveAlamat"
					/>
				</div>
				<div class="p-x-20 w-limit" v-if="pageSetting.pageType.create">
					<SOButton
						:loading="pageSetting.btn.save.loading"
						:disable="pageSetting.btn.save.disabled"
						:full="true"
						:primary="true"
						:text="'Simpan Alamat'"
						@action="createAlamat"
					/>
				</div>
				<div class="p-x-20 w-limit" v-if="pageSetting.pageType.edit">
					<SOButton
						:loading="pageSetting.btn.save.loading"
						:disable="pageSetting.btn.save.disabled"
						:full="true"
						:primary="true"
						:text="'Simpan Alamat'"
						@action="updateAlamat"
					/>
				</div>
			</div>
			<CustomerFormAlamatMap
				v-if="pageSetting.showMap"
				:is-create="pageSetting.pageType.create"
				:is-edit="pageSetting.pageType.edit"
				@close="() => { pageSetting.showMap = false }"
			/>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";

import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOInputTextarea from "@/so-components/global/input/SOInputTextarea";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";
import SOButton from "@/so-components/global/ui/SOButton";
import CustomerFormAlamatMap from "./CustomerFormAlamatMap";

import ErrorMessage from "@/component-items/ErrorMessage";
import {minLength, required} from "vuelidate/lib/validators";


export default {
	name: "CustomerCreateAlamat",
	components: {
		SOTitleBar,
		SOInputTextarea,
		SOInputRegular,
		SOInputCheckbox,
		SOButton,
		CustomerFormAlamatMap,
		ErrorMessage,
	},
	props: {
		idcustomer: {
			type: String,
		},
	},
	computed: {
		...mapGetters("customerModule", {
			alamatTemp: "getAlamatTemp",
			customer: "getDataCreateCustomer",
			detailCustomer2: "getDetailCustomer",
		}),
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			vm.isEdit = from.name === "customerEdit"
		})
	},
	mounted() {
		if (this.$route.params.idcustomer !== undefined && this.$route.params.idalamat !== undefined) {
			this.pageSetting.pageType.default = false
			this.pageSetting.pageType.create = false
			this.pageSetting.pageType.edit = true
			this.pageSetting.pageTitle = "Ubah Alamat"

			this.reverseGeocode()
		} else if (this.$route.params.idcustomer !== undefined) {
			this.alamatTemp.idcustomer = this.$route.params.idcustomer
			this.pageSetting.pageType.default = false
			this.pageSetting.pageType.create = true
			this.pageSetting.pageType.edit = false
			this.pageSetting.pageTitle = "Tambah Alamat"
		} else {
			this.pageSetting.pageTitle = "Tambah Alamat"
		}

		this.alamatOld = JSON.parse(JSON.stringify(this.alamatTemp))
		if (this.alamatOld.alamat !== "") {
			this.pageSetting.pageTitle = "Ubah Alamat"
		}
	},
	data() {
		return {
			isEdit: false,
			checkboxAlamatUtama: {
				name: "alamat-utama",
				data: [
					{
						id: "alamat-utama",
						value: "1",
						title: "Jadikan alamat utama",
						checked: true,
						titleBold: false,
					},
				]
			},
			alamatOld: {},

			pageSetting: {
				btn: {
					save: {
						loading: false,
						disabled: false
					}
				},
				pageType: {
					default: true,
					create: false,
					edit: false,
				},
				pageTitle: "",
				showMap: false,
			},
		}
	},
	validations: {
		alamatTemp: {
			alamat: {
				required,
				minLength: minLength(2),
			}
		}
	},
	methods: {
		back() {
			if (this.pageSetting.pageType.edit || this.pageSetting.pageType.create) {
				// this.$router.push("/konsumen/alamat/" + this.alamatTemp.idcustomer)
				this.$store.commit("customerModule/resetAlamatTemp")
				// return
			}
			// this.$router.push("/konsumen/create/2")
			this.$router.back()
		},
		pinMap() {
			if (this.pageSetting.pageType.edit) {
				this.$router.push("/konsumen/alamat/edit/map/" + this.alamatTemp.idcustomer + "/" + this.alamatTemp.idalamat)
				return
			}
			if (this.pageSetting.pageType.create) {
				this.$router.push("/konsumen/alamat/create/map/" + this.alamatTemp.idcustomer)
				return;
			}
			this.$router.push("/konsumen/create/alamat/map")
		},
		errorValidation() {
			this.$v.alamatTemp.alamat.$touch()
			return this.$v.alamatTemp.alamat.$invalid
		},
		validate() {
			this.pageSetting.btn.save.disabled = this.errorValidation();
		},
		async saveAlamat() {
			if (this.errorValidation()) {
				this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
				return
			}
			await this.checkPrimaryAddress()

			var customer = this.customer
			var alamatOldIndex = customer.alamat_customer.findIndex(
				(a) => a.alamat === this.alamatOld.alamat &&
					a.judul === this.alamatOld.judul
			)
			var temp = JSON.parse(JSON.stringify(this.alamatTemp))
			temp.alamat_utama = (temp.alamat_utama.length > 0) ? temp.alamat_utama[0] : "0"
			if (alamatOldIndex !== -1) {
				customer.alamat_customer[alamatOldIndex] = temp
				await this.$store.commit("customerModule/setDataCreateCustomer", customer)
			} else {
				customer.alamat_customer = [...customer.alamat_customer, temp]
				await this.$store.commit("customerModule/setDataCreateCustomer", customer)
			}
			await this.$store.commit("customerModule/resetAlamatTemp")
			this.back()
		},
		async checkPrimaryAddress() {
			var customer = this.customer
			var primaryIndex = customer.alamat_customer.findIndex((a) => a.alamat_utama === '1')
			if (primaryIndex !== -1) {
				customer.alamat_customer[primaryIndex].alamat_utama = '0'
			}
			await this.$store.commit("customerModule/setDataCreateCustomer", customer)
		},
		async reverseGeocode() {
			if (this.alamatTemp.latitude === 0 && this.alamatTemp.longitude === 0) {
				return
			}
			try {
				const res = await this.$axios.get("https://maps.googleapis.com/maps/api/geocode/json?" +
					"latlng=" + this.alamatTemp.latitude + "," + this.alamatTemp.longitude +
					"&key=" + this.$gmapKey
				)
				this.alamatTemp.alamat_gmaps = res.data.results[0].formatted_address
			} catch (e) {
				this.$toast.error(e)
			}
		},

		async createAlamat() {
			if (this.errorValidation()) {
				this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
				return
			}
			if (this.isEdit) {
				let alamat = JSON.parse(JSON.stringify(this.alamatTemp))
				alamat.alamat_utama = alamat.alamat_utama[0]
				let customer = this.detailCustomer2
				if (alamat.alamat_utama == '1') {
					customer.alamat_customer.forEach(element => {
						element.alamat_utama = '0'
					});
				}
				customer.alamat_customer.push(alamat);
				this.$store.commit("customerModule/setDetailCustomer2", customer)
				this.$router.back();
				return
			}
			this.pageSetting.btn.save.disabled = true
			this.pageSetting.btn.save.loading = true
			const res = await this.$store.dispatch("customerModule/createAlamat", this.alamatTemp.idcustomer)
			this.pageSetting.btn.save.disabled = false
			this.pageSetting.btn.save.loading = false
			if (res.success) {
				this.$toast.success(res.msg)
				this.back()
			} else {
				this.$toast.error(res.err)
			}
		},
		async updateAlamat() {
			if (this.errorValidation()) {
				this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
				return
			}
			if (this.isEdit) {
				let alamat = JSON.parse(JSON.stringify(this.alamatTemp))
				alamat.alamat_utama = alamat.alamat_utama[0]
				let customer = this.detailCustomer2
				customer.alamat_customer[customer.alamat_customer.findIndex(a => a.idalamat === alamat.idalamat)] = alamat
				this.$store.commit("customerModule/setDetailCustomer2", customer)
				this.$router.back();
				return
			}
			this.pageSetting.btn.save.disabled = true
			this.pageSetting.btn.save.loading = true
			const res = await this.$store.dispatch("customerModule/updateAlamat", {
				idcustomer: this.alamatTemp.idcustomer,
				idalamat: this.alamatTemp.idalamat,
			})
			this.pageSetting.btn.save.disabled = false
			this.pageSetting.btn.save.loading = false
			if (res.success) {
				this.$toast.success(res.msg)
				this.back()
			} else {
				this.$toast.error(res.err)
			}
		}
	}
}
</script>